
/**
 * Returns a proxy URL for the given request URL.
 *
 * @param {string} requestURL the original request URL
 * @returns string
 */
export function requestViaProxy(requestURL) {
    return `/proxy/?url=${encodeURIComponent(requestURL)}`;
}